import type {
  AllianceUserRoleVo,
  AllianceUserVo,
  BindPhoneReq,
  UpdateUserReq,
} from "types/openapi/lm";
import { get, post } from "@/http/axios";

export function getUserInfo() {
  return get<AllianceUserVo>({
    url: "/api/lm/alliance/user/getCurrentUserInfo",
  });
}

export function updateUserInfo(data: UpdateUserReq) {
  return post({
    url: "/api/lm/alliance/user/updateUserInfo",
    data,
  });
}
/**
 * 绑定手机号
 */

export function bindPhone(params: BindPhoneReq) {
  return get({
    url: "/api/lm/alliance/user/bindPhone",
    params,
    hiddenLoading: true,
  });
}

/**
 * 获取当前用户在联盟中的角色
 */
export function getUnionRoles(params?: { allianceCode: string }) {
  return get<AllianceUserRoleVo>({
    url: "/api/lm/alliance/user/getCurrentUserRole",
    params,
    hiddenLoading: true,
  });
}
